module.exports = __webpack_public_path__ + "img/banner-pacific-standard.a1b5eb89.png";